
import { defineComponent, inject, onUnmounted, ref } from 'vue'
import { useKeypress } from 'vue3-keypress'

export default defineComponent({
  name: 'Overlay',
  setup() {
    const visible = ref(false)
    const emitter: any = inject('emitter')

    emitter.on('showOverlay', showOverlay)
    emitter.on('hideOverlay', hideOverlay)

    const onHideDialogs = (_) => {
      hideDialogs()
    }

    function showOverlay() {
      visible.value = true
    }

    function hideOverlay() {
      visible.value = false
    }

    function hideDialogs() {
      emitter.emit('hideDialogs')
      visible.value = false
    }

    useKeypress({
      keyEvent: 'keydown',
      keyBinds: [
        {
          keyCode: 27,
          success: hideDialogs
        }
      ]
    })

    onUnmounted(() => {
      emitter.off('showOverlay', showOverlay)
      emitter.off('hideOverlay', hideOverlay)
    })

    return {
      visible,
      onHideDialogs
    }
  }
})
